export const appConfig = {
	title: 'Remote Social Check-in',
	baseUrl: 'remotesocial.io',
	subdomain: 'checkin',
};
